import { Component, EventEmitter, OnDestroy, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';

import { takeUntil } from 'rxjs';

import { OgType, SITE_URL } from '@app/types/seo.types';
import { PortfolioDataService } from '@app/common/services/portfolio-data.service';
import { PortfolioItem } from '@app/types/portfolio.types';
import { ScrollService } from '@app/common/services/scroll.service';
import { SeoService } from '@app/common/services/seo.service';

@Component({
  selector: 'app-portfolio-item-page',
  imports: [RouterLink],
  templateUrl: './portfolio-item-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './portfolio-item-page.component.scss'
})
export class PortfolioItemPageComponent implements OnDestroy, OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private portfolioDataService = inject(PortfolioDataService);
  private scrollService = inject(ScrollService);
  private seoService = inject(SeoService);

  currentItem: PortfolioItem;
  newerItem: PortfolioItem;
  olderItem: PortfolioItem;
  activeImageId: string;

  private allPortfolioItems: PortfolioItem[] = [];
  private destroy$ = new EventEmitter<void>();

  ngOnInit() {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe(async (params) => {
      const slug = params['portfolioItemSlug'];

      this.allPortfolioItems = this.portfolioDataService.getAllPortfolioItems();
      this.currentItem = this.portfolioDataService.getPortfolioItemBySlug(slug);

      const itemIndex = this.allPortfolioItems.findIndex((i) => i._id == this.currentItem._id);
      this.newerItem = this.allPortfolioItems[itemIndex - 1] ?? null;
      this.olderItem = this.allPortfolioItems[itemIndex + 1] ?? null;
      this.activeImageId = this.currentItem.images[0]._id;

      this.seoService.setSeoData({
        title: `${this.currentItem.title} - ${this.currentItem.location}`,
        description: this.currentItem.description,
        keywords: `${this.currentItem.decors.join(', ')}, ${this.currentItem.fittings.join(', ')}`,
        ogImage: {
          url: `${SITE_URL}${this.currentItem.images[0].seoUrl}`,
          alt: this.currentItem.title
        },
        ogUrl: `${SITE_URL}/realizacje/${this.currentItem.slug}`,
        ogType: OgType.Article
      });
      this.scrollService.scrollToTop();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.emit();
  }

  setActiveImageId(imageId: string): void {
    this.activeImageId = imageId;
  }
}
